import {isEmpty as _isEmpty, isUndefined as _isUndefined} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Segment} from 'semantic-ui-react';

import {withApollo} from 'react-apollo';
import {getLink} from '@appComponents/Link';
import Tabs from '@appComponents/Tabs';
import {GetThirdPartyClientDataForStore} from '@graphql/thirdPartyClients/query';
import mapModulesToProps from '@utils/mapModulesToProps';
import {convertToInt} from '@utils/helpers';
import {showErrorModal} from '@utils/modal';
import {productThirdPartyTabsState} from '@modules/client/utils/clientProductThirdPartyLayoutHelper';
import {findProduct} from '@modules/client/utils/clientTabsLayoutHelper';
import {PRODUCT_THIRD_PARTY} from '@modules/app/constants/variables';

class ClientProductThirdPartyLayout extends React.Component {
    static propTypes = {
        client: PropTypes.object.isRequired,
        clientProductThirdParty: PropTypes.shape({
            product: PropTypes.shape({
                has_geolocation_support: PropTypes.bool,
            }),
            third_party_client_product: PropTypes.shape({
                id: PropTypes.string,
            }),
        }).isRequired,
        Entity: PropTypes.object,
        hasCdns: PropTypes.bool,
        hasPullOrigins: PropTypes.bool,
        hasVodStorages: PropTypes.bool,
        hasTunnel: PropTypes.bool,
        match: PropTypes.object.isRequired,
        Modal: PropTypes.object,
    };

    constructor() {
        super();

        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        this.getThirdPartyClientCdnsAndPullOriginsFromGraphQL();
    }

    componentDidUpdate(prevProps) {
        if (this.props.clientProductThirdParty !== prevProps.clientProductThirdParty) {
            this.getThirdPartyClientCdnsAndPullOriginsFromGraphQL();
        }
    }

    prepareThirdPartyClientCdnsForStore = (thirdPartyClientCdnsForStore) => {
        this.props.Entity.setEntity({
            data: {
                cdns: thirdPartyClientCdnsForStore,
            },
            name: 'thirdPartyClientCdns',
        });
    };

    prepareThirdPartyClientPullOriginsForStore = (thirdPartyClientPullOriginsForStore) => {
        this.props.Entity.setEntity({
            data: {
                pullOrigins: thirdPartyClientPullOriginsForStore,
            },
            name: 'thirdPartyClientPullOrigins',
        });
    };
    prepareThirdPartyClientVodStoragesForStore = (thirdPartyClientVodStoragesForStore) => {
        this.props.Entity.setEntity({
            data: {
                vodStorages: thirdPartyClientVodStoragesForStore,
            },
            name: 'thirdPartyClientVodStorages',
        });
    };

    prepareThirdPartyClientTunnelsForStore = (thirdPartyClientTunnelsForStore) => {
        this.props.Entity.setEntity({
            data: {
                tunnels: thirdPartyClientTunnelsForStore,
            },
            name: 'thirdPartyClientTunnels',
        });
    };

    getThirdPartyClientCdnsAndPullOriginsFromGraphQL = () => {
        if (_isUndefined(this.props.clientProductThirdParty?.third_party_client_product)) {
            return;
        }

        this.setState(() => {
            return {
                loading: true,
            };
        });

        this.props.client.query({
            fetchPolicy: 'cache-first',
            query: GetThirdPartyClientDataForStore,
            variables: {
                clientProductThirdParty: convertToInt(this.props.clientProductThirdParty?.third_party_client_product.id),
            },
        }).then((data) => {
            if (data) {
                this.prepareThirdPartyClientCdnsForStore(data.data.thirdPartyClientCdns);
                this.prepareThirdPartyClientPullOriginsForStore(data.data.thirdPartyClientPullOrigins);
                this.prepareThirdPartyClientTunnelsForStore(data.data.thirdPartyClientTunnels);
                this.prepareThirdPartyClientVodStoragesForStore(data.data.thirdPartyClientVodStorages);
            }

            this.setState(() => {
                return {
                    loading: false,
                };
            });
        }).catch(() => {
            this.setState(() => ({loading: false}));

            showErrorModal({
                header: 'Third party was not found',
                text: 'Third party was not found',
                errorButtonText: 'Back to clients',
                hideButtons: false,
                redirectLink: getLink('clients.index'),
                errorButtonIcon: 'arrow circle left',
            });
        });
    };

    getProductThirdPartyTabsState = (props) => {
        return productThirdPartyTabsState(
            props,
            this.prepareThirdPartyClientCdnsForStore,
            this.prepareThirdPartyClientPullOriginsForStore,
            this.prepareThirdPartyClientTunnelsForStore,
            this.prepareThirdPartyClientVodStoragesForStore
        );
    };

    render() {
        const {active = '', tabs = {}} = this.getProductThirdPartyTabsState(this.props);

        return (
            (this.state.loading)
                ? <Segment basic loading={true} padded='very'/>
                : <Tabs active={active} items={tabs} level={2}
                    segmentClassName='--marginTopNegative-15 --paddingTop-0'/>
        );
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity', 'MessageBox', 'Modal']);

const mapStateToProps = (state) => {
    let hasCdns,
        hasPullOrigins,
        hasTunnel,
        hasVodStorages;

    const cdnsInStore = state.app.entities.thirdPartyClientCdns,
        pullOriginsInStore = state.app.entities.thirdPartyClientPullOrigins,
        tunnelsInStore = state.app.entities.thirdPartyClientTunnels,
        vodStoragesInStore = state.app.entities.thirdPartyClientVodStorages;

    if (!_isUndefined(cdnsInStore)) {
        hasCdns = !_isEmpty(cdnsInStore.cdns);
    }

    if (!_isUndefined(pullOriginsInStore)) {
        hasPullOrigins = !_isEmpty(pullOriginsInStore.pullOrigins);
    }

    if (!_isUndefined(tunnelsInStore)) {
        hasTunnel = !_isEmpty(tunnelsInStore.tunnels);
    }

    if (!_isUndefined(vodStoragesInStore)) {
        hasVodStorages = !_isEmpty(vodStoragesInStore.vodStorages);
    }

    return {
        hasCdns: hasCdns,
        hasPullOrigins: hasPullOrigins,
        hasTunnel: hasTunnel,
        hasVodStorages: hasVodStorages,
        clientProductThirdParty: findProduct(state.app.entities.client.clientProducts, PRODUCT_THIRD_PARTY),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withApollo(ClientProductThirdPartyLayout)));
